import type { DashboardBreakdownEntry } from '@shared/types';

/**
 * A `{ key, count }[]` breakdown as a small inline pill row — the dashboard's
 * "By platform" tile, and any game section's own breakdowns (#817). Empty
 * renders an em dash rather than an empty row.
 */
export default function Breakdown({
  entries,
  testId,
}: {
  entries: readonly DashboardBreakdownEntry[];
  testId: string;
}) {
  if (entries.length === 0) {
    return <span className="text-xs text-slate-400">—</span>;
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {entries.map((e) => (
        <span
          key={e.key}
          className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-700"
        >
          <span className="font-medium">{e.key}</span>
          <span className="tabular-nums text-slate-500">{e.count.toLocaleString()}</span>
        </span>
      ))}
    </div>
  );
}
